'use strict';

exports.__esModule = true;
exports.bookHealthCheckModal = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _reduxSimpleAuth = require('redux-simple-auth');

var _bookHealthCheckModal = require('../actions/book-health-check-modal');

var _pageActions = require('../actions/page-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const transformProfile = ({ state, account, profile }) => {
// 	return {
// 		requestData: {
// 			...state.requestData,
// 			patient_id: profile.uuid,
// 			firstname: profile.firstname,
// 			lastname: profile.lastname,
// 			email: account.name,
// 			attributes: {
// 				...state.attributes,
// 				birthdate: profile.attributes.birthdate,
// 				gender: profile.attributes.gender
// 			}
// 		}
// 	};
// };

var LAST_2_CHARS = -2;

var INITIAL_STATE = {
	isOpen: false,
	selectedPackage: {},
	patient: {},
	requestData: {
		attributes: {
			birthdate: '00-xxx-0000',
			gender: '',
			health_check_type: '',
			package_id: null,
			phone: '',
			user_type: 'patient'
		},
		create_account: false,
		email: '',
		firstname: '',
		id: '',
		lastname: '',
		message: '',
		password: '',
		patient_id: null,
		phone: '',
		practice: '',
		request_type: 'health_check_request',
		source_application: 'website',
		token: ''
	},
	submitFailed: false,
	submitSuccessful: false
};

var bookHealthCheckModal = exports.bookHealthCheckModal = function bookHealthCheckModal(state, action) {
	switch (action.type) {
		case _pageActions.LOAD_PRACTICE_PROFILE + '_RECEIVED':
			return (0, _assign2.default)({}, state, { practice: action.response.practice, requestData: (0, _extends3.default)({}, state.requestData, { id: action.response.practice.id }) });
		case _bookHealthCheckModal.FIRST_NAME_CHANGE:
			return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { firstname: action.name }) });
		case _bookHealthCheckModal.LAST_NAME_CHANGE:
			return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { lastname: action.name }) });
		case _bookHealthCheckModal.EMAIL_CHANGE:
			return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { email: action.email }) });
		case _bookHealthCheckModal.PHONE_CHANGE:
			return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { attributes: (0, _extends3.default)({}, state.requestData.attributes, { phone: action.phone }), phone: action.phone }) });
		case _bookHealthCheckModal.SEX_CHANGE:
			return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { attributes: (0, _extends3.default)({}, state.requestData.attributes, { gender: action.gender }) }) });
		case _bookHealthCheckModal.BIRTHDATE_DAY_CHANGE:
			return (0, _assign2.default)({}, state, {
				requestData: (0, _extends3.default)({}, state.requestData, {
					attributes: (0, _extends3.default)({}, state.requestData.attributes, {
						birthdate: state.requestData.attributes.birthdate.replace(/^\d{2}/, ('0' + action.day).slice(LAST_2_CHARS))
					})
				})
			});
		case _bookHealthCheckModal.BIRTHDATE_MONTH_CHANGE:
			return (0, _assign2.default)({}, state, {
				requestData: (0, _extends3.default)({}, state.requestData, {
					attributes: (0, _extends3.default)({}, state.requestData.attributes, {
						birthdate: state.requestData.attributes.birthdate.replace(/\b[a-zA-Z]{3}\b/, action.month)
					})
				})
			});
		case _bookHealthCheckModal.BIRTHDATE_YEAR_CHANGE:
			return (0, _assign2.default)({}, state, {
				requestData: (0, _extends3.default)({}, state.requestData, {
					attributes: (0, _extends3.default)({}, state.requestData.attributes, {
						birthdate: state.requestData.attributes.birthdate.replace(/\d{4}/, action.year)
					})
				})
			});
		case _bookHealthCheckModal.REASON_FOR_VISIT_CHANGE:
			return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { message: action.reason }) });
		case _bookHealthCheckModal.PROMO_CODE_CHANGE:
			return (0, _assign2.default)({}, state, { promoCode: action.code, promoCodeEntered: false });
		case _bookHealthCheckModal.VALIDATE_PROMO_CODE + '_RECEIVED':
			return (0, _assign2.default)({}, state, {
				requestData: (0, _extends3.default)({}, state.requestData, {
					promotion_code: {
						code: state.promoCode,
						entitlement: action.response.entitlement
					}
				}),
				promoCodeEntered: true,
				validPromoCode: true
			});
		case _bookHealthCheckModal.VALIDATE_PROMO_CODE + '_FAILED':
			{
				return (0, _assign2.default)({}, state, { promoCodeEntered: true, validPromoCode: false });
			}
		case _bookHealthCheckModal.CLOSE_MODAL:
			return (0, _assign2.default)({}, state, { isOpen: false, submitFailed: false, submitSuccessful: false, promoCodeEntered: false, validPromoCode: false });
		case _bookHealthCheckModal.OPEN_MODAL:
			return (0, _assign2.default)({}, state, {
				isOpen: true,
				selectedPackage: action.packageData,
				requestData: (0, _extends3.default)({}, state.requestData, {
					attributes: (0, _extends3.default)({}, state.requestData.attributes, {
						gender: action.accountProfileData && action.accountProfileData.patient && action.accountProfileData.patient.gender || '',
						birthdate: action.accountProfileData && action.accountProfileData.patient && action.accountProfileData.patient.birthdate || '00-xxx-0000',
						package_id: action.packageData.id,
						health_check_type: action.packageData.package_name
					}),
					email: action.accountProfileData && action.accountProfileData.patient && action.accountProfileData.patient.email || '',
					firstname: action.accountProfileData && action.accountProfileData.patient && action.accountProfileData.patient.firstname || '',
					lastname: action.accountProfileData && action.accountProfileData.patient && action.accountProfileData.patient.lastname || ''
				})
			});
		case _bookHealthCheckModal.SET_PACKAGE_TYPE:
			return (0, _assign2.default)({}, state, { packageType: action.packageType });
		case _bookHealthCheckModal.VALIDATION_ERROR:
			return (0, _assign2.default)({}, state, { submitFailed: true });
		case _bookHealthCheckModal.SUBMIT_FORM + '_RECEIVED':
			return (0, _assign2.default)({}, state, { submitFailed: false, submitSuccessful: true });
		case _reduxSimpleAuth.actionTypes.RESTORE:
		case _reduxSimpleAuth.actionTypes.AUTHENTICATE_SUCCEEDED:
			return (0, _assign2.default)({}, state, {
				requestData: (0, _extends3.default)({}, state.requestData, {
					patient_id: action.payload.selectedProfile.id
				})
			});
		case _reduxSimpleAuth.actionTypes.INVALIDATE_SESSION:
			return (0, _assign2.default)({}, state, {
				requestData: (0, _extends3.default)({}, state.requestData, {
					patient_id: '',
					email: '',
					firstname: '',
					lastname: '',
					attributes: (0, _extends3.default)({}, state.attributes, {
						birthdate: '00-xxx-0000',
						gender: ''
					})
				})
			});
		default:
			return state || INITIAL_STATE;
	}
};


// WEBPACK FOOTER //
// ./components/practice-page/lib/reducers/book-health-check-modal.js